import { Routes } from '@angular/router';

export const content: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('../../components/home/home.routes').then((m) => m.home),
  },
  {
    path: '',
    loadChildren: () =>
      import('../../components/pages/page.routes').then((m) => m.page),
  },
  {
    path: '',
    loadChildren: () =>
      import('../../components/shop/shop.routes').then((m) => m.shop),
  },
];
